module.exports = __webpack_public_path__ + "img/archimed2.56f2ea71.png";